const $body = $('body');

$.fn.initTooltip = function(i, e) {
    let $trigger = $(this),
        ttText = $(this).attr('title');

    if (typeof ttText !== 'undefined') {

        let ttClass = 'tooltip',
            ttPlacement = $(this).attr('data-placement');

        if (typeof ttPlacement !== 'undefined') {
            ttClass += ' tooltip--placement-' + ttPlacement;
        }

        let $tooltip = $('<div class="' + ttClass + '" role="tooltip"><div class="tooltip__arrow"></div><div class="tooltip__inner">' + ttText + '</div></div>');

        $(this).on('mouseover focus', function () {
            let ttID = 'tooltip-' + randomInteger(10000, 99999);

            $body.append($tooltip);

            $tooltip.attr('id', ttID);
            $tooltip.setTooltipPosition($trigger, ttPlacement);

            $trigger.attr('aria-describedby', ttID).attr('title', '').attr('data-original-title', ttText);
        }).on('mouseout focusout', function () {
            $tooltip.remove();
            $trigger.attr('aria-describedby', '').attr('title', ttText).attr('data-original-title', '');
        });
    }
}

function randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

$.fn.setTooltipPosition = function($trigger = false, ttPlacement) {
    let $tooltip = $(this),
        $tooltipArrow = $('.tooltip__arrow', this),
        ttPosX,
        ttPosY;

    if (!$trigger) return false;

    if (typeof ttPlacement === 'undefined' || 'top' === ttPlacement) {
        ttPosX = $trigger.offset().left + $trigger.outerWidth() / 2 - $tooltip.outerWidth() / 2;
        ttPosY = $trigger.offset().top - $body.innerHeight();
    } else if ('right' === ttPlacement) {
        ttPosX = $trigger.offset().left + $trigger.outerWidth();
        ttPosY = $trigger.offset().top + $trigger.outerHeight() / 2 - $tooltip.outerHeight() / 2;
    } else if ('bottom' === ttPlacement) {
        ttPosX = $trigger.offset().left + $trigger.outerWidth() / 2 - $tooltip.outerWidth() / 2;
        ttPosY = $trigger.offset().top + $trigger.outerHeight();
    } else if ('left' === ttPlacement) {
        ttPosX = $trigger.offset().left - $body.innerWidth();
        ttPosY = $trigger.offset().top + $trigger.outerHeight() / 2 - $tooltip.outerHeight() / 2;
    }

    // set initial position
    $tooltip.css('transform', 'translate3d(' + ttPosX + 'px, ' + ttPosY + 'px, 0)');

    let diffX = 0,
        diffY = 0,
        ttaPosX = 0,
        ttaPosY = 0,
        bufferSize = 20;

    // move tooltip content if content exceeds window size
    if ($tooltip.offset().left < 0) {
        // console.log('tooltip exceeds window left');

        diffX = (-1 * $tooltip.offset().left) + bufferSize;
        ttPosX = ttPosX + diffX;
        ttaPosX = -1 * diffX;
    } else if ($tooltip.offset().left + $tooltip.outerWidth() > viewport().width) {
        // console.log('tooltip exceeds window right');

        diffX = $tooltip.offset().left + $tooltip.outerWidth() - viewport().width + bufferSize
        ttPosX = ttPosX - diffX;
        ttaPosX = diffX;
    } else if ($tooltip.offset().top < 0) {
        // console.log('tooltip exceeds window top');

        diffY = (-1 * $tooltip.offset().left) + bufferSize;
        ttPosY = ttPosY + diffY;
        ttaPosY = -1 * diffY;
    } else if ($tooltip.offset().top + $tooltip.outerHeight() > $(document).height()) {
        // console.log('tooltip exceeds window bottom');

        diffY = $tooltip.offset().top + $tooltip.outerHeight() - $(document).height() + bufferSize;
        ttPosY = ttPosY - diffY;
        ttaPosY = diffY;
    }

    // adjust position
    $tooltip.css('transform', 'translate3d(' + ttPosX + 'px, ' + ttPosY + 'px, 0)');
    $tooltipArrow.css('transform', 'translate3d(' + ttaPosX + 'px, ' + ttaPosY + 'px, 0)');
}

let docHeight = $(window).height(),
    docWidth = $(window).width();

// adjust open tooltip position on window resize
$(window).on('resize', function () {
    // before repositioning, check if document sizes have changed first
    if ($(window).height() != docHeight || $(window).width() != docWidth) {
        docHeight = $(window).height();
        docWidth = $(window).width();

        $('.tooltip').each(function () {
            let $tooltip = $(this),
                $trigger = $('[aria-describedby="' + $tooltip.attr('id') + '"]'),
                ttPlacement = $trigger.attr('data-placement');

            $tooltip.setTooltipPosition($trigger, ttPlacement);
        });
    }
});

$('[data-toggle="tooltip"]').each(function () {
    $(this).initTooltip();
});

// START MutationObserver - use this to init tooltips on dynamically added elements

const observerTargetNode = document.documentElement;

const observerConfig = { attributes: true, childList: true, subtree: true };

const observerCallback = (mutationList, observer) => {
    const found = [];

    for (const { addedNodes } of mutationList) {
        for (const node of addedNodes) {
            if (!node.tagName) continue; // not an element

            if ($(node).data('toggle') === 'tooltip') {
                found.push(node);
            }
        }
    }

    if (found.length > 0) {
        found.forEach((element) => $(element).initTooltip()); // console.log(element)); // initTooltip
    }
};

const observer = new MutationObserver(observerCallback);

observer.observe(observerTargetNode, observerConfig);

setTimeout(function () {
    observer.disconnect();
}, 5000);

// END MutationObserver
